const UPDATE_STORE = '3000_UPDATE_STORE';
export default UPDATE_STORE;
